import { useEffect, useState } from 'react';
import { useInstallationContext } from '../../../../../context/installation';
import { UserGroup } from '../../../../../data-access/gql-types/graphql';
import { useRefetchData } from '../../../../../hooks/refresh-data/use-refetch-data';
import { useDevicesAndChannelsContext } from '../../../context/devices-and-channels';
import { useGroups } from '../../../hooks/groups/use-groups';
import * as storage from '../../../storage';
import { useChannelsStore } from '../../../store/channels';
import { useDevicesStore } from '../../../store/devices';

export const useUserGroups = () => {
  const { installationList, selectedInstallation } = useInstallationContext();
  const { channelList } = useDevicesAndChannelsContext();
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const { groupsLoading, groups } = useGroups();
  const { refetchAll } = useRefetchData();
  const channelsLoading = useChannelsStore((s) => s.channelsLoading);
  const devicesLoading = useDevicesStore((s) => s.devicesLoading);

  useEffect(() => {
    const index = groups.findIndex((group: UserGroup) => group.id === storage.getItem('lastActiveGroupId'));
    setActiveTabIndex(index < 0 ? 0 : index);
  }, [groups]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!installationList.length) refetchAll();
    }, 300);

    return () => clearTimeout(timeout);
  }, [installationList.length]);

  const handleSetActiveGroupIndex = (index: number) => {
    setActiveTabIndex(index);
    storage.setItem('lastActiveGroupId', String(groups[index]?.id));
  };

  const groupTabsVisible =
    selectedInstallation && channelList.length > 0 && !groupsLoading && !devicesLoading && !channelsLoading;

  return {
    activeTabIndex,
    activeGroup: groups[activeTabIndex],
    isCarouselContent: !!selectedInstallation,
    groupTabsVisible,
    handleSetActiveGroupIndex,
  };
};
